/**
 * Documentos Module Routes — granular (2026-04-21)
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const DocumentDashboardPage = lazy(() =>
  import("@/pages/documents/DocumentDashboardPage").then((m) => ({
    default: m.DocumentDashboardPage,
  }))
);
const DocumentosDashboard = lazy(() => import("@/pages/documentos/Dashboard"));
const DocumentosListagem = lazy(() => import("@/pages/documentos/Listagem"));
const DocumentosLixeira = lazy(() => import("@/pages/documentos/Lixeira"));
// E14.1.4 — Drive Browser (nova VIEW do módulo documentos: árvore + navegador).
const DriveBrowser = lazy(() => import("@/pages/drive/DriveBrowserPage"));
// Biblioteca da Qualidade — área de auditoria das exclusões (quem excluiu o quê, quando e por quê).
const ExclusoesDaBiblioteca = lazy(() => import("@/pages/drive/ExclusoesDaBibliotecaPage"));

export const documentosRoutes: ModuleRoutes = {
  moduleId: "documentos",
  basePath: "/documentos",
  routes: [
    {
      path: "/documentos",
      element: <DocumentDashboardPage />,
      permission: { resource: "documentos_dashboard", action: "view" },
    },
    {
      // Drive: navegador de pastas + documentos (E14.1.4). Reusa a RBAC de
      // listagem (sem permissão nova) — aparece onde "Documentos → Listagem".
      path: "/drive",
      element: <DriveBrowser />,
      permission: { resource: "documentos_listagem", action: "view" },
    },
    {
      // Auditoria das exclusões da Biblioteca. Mesma permissão da lista do backend (`audit:read`):
      // quem restaura é decidido por linha (`pode_restaurar`), não pela rota.
      //
      // ⚠️ Declarada ANTES de `/drive/:pastaId` de propósito: o endereço dela começa igual ao de
      //    uma pasta, e é a ordem aqui que deixa claro quem é quem. Sem entrada no Sidebar (o
      //    acesso é o link "Exclusões" do Drive, dentro da Biblioteca).
      path: "/drive/biblioteca/exclusoes",
      element: <ExclusoesDaBiblioteca />,
      permission: { resource: "audit", action: "read" },
    },
    {
      // A MESMA tela, com a pasta no endereço. Existe para o link sobreviver ao
      // F5 e poder ser mandado a alguém.
      //
      // ⚠️ Mesma permissão de propósito: quem alcança a pasta é decidido pela
      //    ACL dela, não pela rota. Pasta fora do alcance responde 404.
      path: "/drive/:pastaId",
      element: <DriveBrowser />,
      permission: { resource: "documentos_listagem", action: "view" },
    },
    {
      path: "/documentos/dashboard",
      element: <DocumentosDashboard />,
      permission: { resource: "documentos_dashboard", action: "view" },
    },
    {
      path: "/documentos/listagem",
      element: <DocumentosListagem />,
      permission: { resource: "documentos_listagem", action: "view" },
    },
    {
      path: "/documentos/lixeira",
      element: <DocumentosLixeira />,
      permission: { resource: "documentos_lixeira", action: "view" },
    },
  ],
};
